import React from "react";
import {FINANCE} from "../../../config/resources";
import {useTranslation} from "react-i18next";


export function FinanceStatusCell({value, rowOriginal}){
    const {t} = useTranslation();

    return (
        <div className={`${value === FINANCE.STATUS.ERROR ? 'text-red-800' : ''}`}>
            {t(`list.finance.status_${value}`)}
            {value === FINANCE.STATUS.ERROR && rowOriginal.data?.error_message && <small className={`block mt-2`}>
                {t(`list.finance.error.${rowOriginal.data?.error_message}`)}
            </small>}
        </div>
    )
}
